import { FiasRegion } from "../../../FiasInput/Types/FiasTypes";
import { isNotNullOrEmpty } from "../../../../../../../../Common/TypingUtils";

export function isRegionMatchToFilterString(region: FiasRegion, searchString: string): boolean {
    const startWthCode = region.code?.startsWith(searchString);
    const startWthPostalCode = region.postalCode?.startsWith(searchString);
    const startWithName = searchString
        .split(" ")
        .map(x => x.toLowerCase())
        .some(searchStringPart => region.name.toLowerCase().includes(searchStringPart));

    const isMatch = Boolean(startWthCode || startWthPostalCode || startWithName);

    return isMatch;
}

export type SelectType = Array<[string | undefined, string]>;

export const addClearOptionToArrayByExistItem = (array: SelectType, item: string | undefined): SelectType => {
    if (isNotNullOrEmpty(item)) {
        array.unshift([undefined, "Очистить"]);
    }
    return array;
};

export const getMunicipalDistrictItems = (type: string | undefined, withFederalTerritory?: boolean): SelectType => {
    const municipalDistrictItems = addClearOptionToArrayByExistItem(
        [
            ["1", "Муниципальный район - м.р-н"],
            ["2", "Городской округ - г.о."],
            ["3", "Внутригородская территория города федерального значения  - вн.тер.г."],
            ["4", "Муниципальный округ - м.о."],
        ],
        type
    );
    if (withFederalTerritory) {
        municipalDistrictItems.push(["5", "Федеральная территория - ф.т."]);
    }
    return municipalDistrictItems;
};

export const getUrbanSettlementItems = (type: string | undefined): SelectType =>
    addClearOptionToArrayByExistItem(
        [
            ["1", "Городское поселение - г.п."],
            ["2", "Сельское поселение - с.п. "],
            ["3", "Межселенная территория в составе муниципального района - межсел.тер."],
            ["4", "Внутригородской район городского округа - вн.р-н "],
        ],
        type
    );

export const getBuildingItems = (type: string | undefined): SelectType =>
    addClearOptionToArrayByExistItem(
        [
            ["Владение", "Владение - влд."],
            ["Дом", "Дом	- д."],
            ["Домовладение", "Домовладение - двлд."],
            ["Гараж", "Гараж - г-ж"],
            ["Здание", "Здание - зд."],
            ["Шахта", "Шахта - шахта"],
            ["Строение", "Строение - стр."],
            ["Сооружение", "Сооружение - соор."],
            ["Литера", "Литера - литера"],
            ["Корпус", "Корпус - к."],
            ["Подвал", "Подвал - подв."],
            ["Котельная", "Котельная - кот."],
            ["Погреб", "Погреб - пб."],
            ["Объект нез-го стр-ва", "Объект нез-го стр-ва - ОНС"],
        ],
        type
    );

export const getAddBuildingItems = (type: string | undefined): SelectType =>
    addClearOptionToArrayByExistItem(
        [
            ["Строение", "Строение - стр."],
            ["Сооружение", "Сооружение - соор."],
            ["Литера", "Литера - литера"],
            ["Корпус", "Корпус - к."],
        ],
        type
    );
